<template>
    <div class="vx-col md:w-full sm:w-auto">
        <div class="vx-row md:w-full">
            <vx-tooltip class="position-icon" :text="$t('timeKeeping.detailCheck')" position="top">
                <feather-icon icon="EyeIcon" class="action-success icon-btn"
                              svgClasses="h-5 w-5 hover:text-primary cursor-pointer"
                              @click="showDetail"/>
            </vx-tooltip>

            <vx-tooltip class="position-icon" :text="$t('timeKeeping.approve')" position="top" v-if="isPermissionAccept() && !params.data.checkinTime">
                <feather-icon icon="CheckIcon" class="action-success icon-btn"
                              svgClasses="h-5 w-5 hover:text-primary cursor-pointer"
                              @click="confirmUpdateRecord"/>
            </vx-tooltip>
        </div>
        <vs-popup class="holamundo"  title="Chi tiết phòng ban" :active.sync="openTimeKeepingDetails" v-if="openTimeKeepingDetails" id="details-time-keeping">
            <TimeKeepingDetail :employeeId="params.data.employeeId"></TimeKeepingDetail>
        </vs-popup>
    </div>
</template>

<script>

import { isAPI, isRouter } from '../../../../store/permission';
import { constAPI, constRouter } from '../../../../store/constant';
import TimeKeepingDetail from "../TimeKeepingDetail";

export default {
    name: 'CellRendererActions',
    components: {
        TimeKeepingDetail
    },
    data() {
        return {
            openTimeKeepingDetails: false,
        }
    },
    methods: {
        isPermissionAccept() {
            return isAPI(this, constAPI.time_keeping_accept)
        },
        showDetail() {
            // this.$router.push(`/user/time-keeping-detail?branch_id=${this.params.data.branchId}&id=${this.params.data.employeeId}`).catch(() => {
            // })
            this.openTimeKeepingDetails = true;
        },
        confirmUpdateRecord() {
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: `Xác nhận chấm công`,
                text: `Bạn có chắc muốn chấm công cho ${this.params.data.fullName} không?`,
                accept: this.verify,
                acceptText: "Có",
                cancelText: "Không"
            })
        },
        verify() {
            let formData = {
                "employeeId": this.params.data.employeeId,
                "createdAt": new Date(),
                "imageUrl": null
            }
            this.$crm.post('/time-keeping/update-time-keeping', formData).then((res) => {
                if (res.data) {
                    this.showVerifySuccess();
                } else {
                    this.showVerifyErr();
                }
                this.$store.commit('UPDATE_CHECKIN_CHECKOUT', true);
                this.$vs.loading.close();
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },
        showVerifySuccess() {
            this.$vs.notify({
                color: 'success',
                text: 'Xác nhận thành công.',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
            })
        },
        showVerifyErr() {
            return this.$vs.notify({
                text: "Thời gian không nằm trong khoảng thời gian chấm công.",
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'danger'
            });
        }
    }
}
</script>
<style lang="scss">
#details-time-keeping {
    .vs-popup {
        width: 1400px !important;
    }
}
</style>

